import type React from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { useStyles } from 'components/lists/styles';
import { BodyXLarge } from 'components/typography/Typography';

export interface AvoidanceRuleItemProps {
  description?: string;
  icon: React.ReactNode;
  name: string;
  readOnly?: boolean;
  type: string;
  onClickViewGroup?: () => void;
}

const AvoidanceRuleOrGroupItem: React.FC<React.PropsWithChildren<AvoidanceRuleItemProps>> = ({
  description,
  icon,
  name,
  readOnly,
  type,
  onClickViewGroup,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container className={classes.listItemWrapper} direction="row" justifyContent="space-between">
      <Grid item>
        <Grid container direction="column">
          <Grid item>
            <Typography className={classes.listItemNameTypography}>{name}</Typography>
          </Grid>
          {!!description && (
            <Grid item>
              <Typography className={classes.listItemDescriptionTypography}>{description}</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      {readOnly ? (
        type === 'GROUP' ? (
          <Grid item className={classes.viewGroup} onClick={onClickViewGroup}>
            <BodyXLarge className={classes.viewGroupAction}>{t('view')}</BodyXLarge>
          </Grid>
        ) : null
      ) : (
        <Grid item className={classes.avoidanceRuleOrGroupIcon}>
          {icon}
        </Grid>
      )}
    </Grid>
  );
};

export default AvoidanceRuleOrGroupItem;
